"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicensesService = void 0;
class LicensesService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getLicenses({ query, cursor, rows, mailto, offset, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/licenses',
            query: {
                'query': query,
                'cursor': cursor,
                'rows': rows,
                'mailto': mailto,
                'offset': offset,
            },
        });
    }
}
exports.LicensesService = LicensesService;
//# sourceMappingURL=LicensesService.js.map